if (!customElements.get('localization-form-custom')) {
  customElements.define(
    'localization-form-custom',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
            input_lang: this.querySelector('input[name="locale_code"]'),
            input_currency: this.querySelector('input[name="currency_code"]'),
            button: this.querySelector('button'),
            panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));

        if (window.Shopify) {
            if (window.Shopify.currency.active === 'USD') {
                this.querySelector('.fc-currency-languages-current').textContent = 'English - $USD';
            } else {
                if (window.Shopify.locale === 'fr') {
                    this.querySelector('.fc-currency-languages-current').textContent = 'Francais - $CAD';
                } else {
                    this.querySelector('.fc-currency-languages-current').textContent = 'English - $CAD';
                }
            }

            // Patch de l'américain en navigateur FR
            if (window.Shopify.currency.active === 'USD' && window.Shopify.locale === 'fr') {
                localeCodeInput.value = 'en';
                currencyCodeInput.value = 'USD';
                currencyForm.submit();
            }
        }
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input_lang.value = event.currentTarget.dataset.lang;
        this.elements.input_currency.value = event.currentTarget.dataset.currency;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
